export const serializeValue = <Value>(value?: Value) =>
  typeof value === 'object' ? JSON.stringify(value) : value?.toString() || ''
